"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shipmentBookingStatus = void 0;
exports.shipmentBookingStatus = { "CREATED": { "status": { "code": "xB", "localize": { "en": "created" } } }, "BOOKED": { "status": { "code": "B", "localize": { "en": "booked" } } }, "CANCELLED": { "status": { "code": "C", "localize": { "en": "cancelled" } } } };
